module.exports = __webpack_public_path__ + "img/9.b2fb2796.jpg";